import { log } from "@lululemon/mwa-utils";

/**
 * Gets the outfitCurrentOpenedMab from the sessionStorage.
 * @returns {Array.<string>}
 */
export const getFromStorage = () => {
  let openedMab = [];
  try {
    const currentOpenedMab = window.sessionStorage.getItem(
      "outfitCurrentOpenedMab"
    );
    if (currentOpenedMab) {
      openedMab = JSON.parse(currentOpenedMab);
    }
  } catch (err) {
    log.error("getFromStorage() - Error getting the storage", err);
  }
  return openedMab;
};

/**
 * Persists the key "outfitCurrentOpenedMab" to the sessionStorage.
 * @param {*} data
 * @return {void}
 */
export const persistInStorage = (data) => {
  try {
    window.sessionStorage.setItem(
      "outfitCurrentOpenedMab",
      JSON.stringify(data)
    );
  } catch (err) {
    log.error("persistInStorage() - Error persisting in the storage", err);
  }
};
